// These are all the current roles that we should use as strings.
const userRoles = {
  ADMINISTRATOR: "administrator",
  INSTRUCTOR: "instructor",
  TRAINER: "trainer",
  LEARNER: "learner",
};

export default userRoles;
